import React, { useState, useEffect } from 'react';
import { useAuth } from '../../context/AuthContext';
import { Navigate } from 'react-router-dom';
import { 
  FiFacebook, FiCalendar, FiCpu, FiPlusCircle, FiTrash2, 
  FiEdit3, FiSend, FiCopy, FiImage, FiSave, FiCheckCircle, FiAlertCircle, FiX, FiRefreshCw
} from 'react-icons/fi';
import Swal from 'sweetalert2';

const API_URL = 'https://app.thundermaxhome.com/api.php';

export default function FacebookAutomationPage() {
  const { user } = useAuth();
  const [posts, setPosts] = useState([]);
  const [selectedPost, setSelectedPost] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [startDate, setStartDate] = useState(new Date().toISOString().split('T')[0]);

  // Modal สำหรับสร้าง/แก้ไขโพสต์ด้วยตนเอง
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalForm, setModalForm] = useState({
    id: null,
    post_date: '',
    title: '',
    caption: '',
    hashtags: '',
    image_prompt: '',
    image_url: '',
    status: 'pending'
  });

  // เช็คสิทธิ์ไอที/เจ้าของ
  const isITOrOwner = user?.role === 'owner' || user?.role === 'it' || user?.username === 'it' || user?.username === 'owner';

  if (!isITOrOwner) {
    return <Navigate to="/admin/dashboard" />;
  }

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = () => {
    setIsLoading(true);
    fetch(`${API_URL}?action=get_fb_posts`)
      .then(res => res.json())
      .then(data => {
        if (data.success) {
          setPosts(data.data);
          // เลือกโพสต์แรกแสดงพรีวิวเป็นค่าเริ่มต้น
          if (data.data.length > 0) {
            setSelectedPost(data.data[0]);
          }
        }
        setIsLoading(false);
      })
      .catch(err => {
        console.error('Error fetching fb posts:', err);
        setIsLoading(false);
      });
  };

  // 🚀 สุ่มสร้างบทความความรู้ไฟฟ้า 30 วันอัตโนมัติ
  const handleGenerate30d = () => {
    Swal.fire({
      title: 'สร้างบทความ 30 วัน?',
      text: 'ระบบจะสุ่มบทความความรู้เรื่องไฟฟ้า แฮชแท็ก และ Prompt เจนรูปภาพล่วงหน้า 30 วันต่อเนื่อง และจะล้างรายการรอดำเนินการ (Pending) เก่าออกเพื่อจัดตารางใหม่',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#4f46e5',
      cancelButtonColor: '#6b7280',
      confirmButtonText: 'ตกลง สร้างทันที',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({ title: 'กำลังเขียนคอนเทนต์...', didOpen: () => Swal.showLoading() });
        fetch(`${API_URL}?action=generate_30d_posts`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ startDate })
        })
        .then(res => res.json())
        .then(data => {
          Swal.close();
          if (data.success) {
            Swal.fire('สำเร็จ!', data.message, 'success');
            fetchPosts();
          } else {
            Swal.fire('ล้มเหลว', data.message, 'error');
          }
        });
      }
    });
  };

  // 💾 บันทึกการแก้ไข/สร้างใหม่แบบแมนนวล
  const handleSavePost = (e) => {
    e.preventDefault();
    const action = modalForm.id ? 'update_fb_post' : 'add_fb_post';
    
    fetch(`${API_URL}?action=${action}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(modalForm)
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        Swal.fire('สำเร็จ', data.message, 'success');
        setIsModalOpen(false);
        fetchPosts();
      } else {
        Swal.fire('ข้อผิดพลาด', data.message, 'error');
      }
    });
  };

  // 🗑️ ลบโพสต์
  const handleDeletePost = (id, e) => {
    e.stopPropagation();
    Swal.fire({
      title: 'ลบตารางโพสต์นี้?',
      text: 'คุณต้องการลบตารางวันโพสต์นี้ออกจากปฏิทินหรือไม่?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ef4444',
      confirmButtonText: 'ลบเลย',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.isConfirmed) {
        fetch(`${API_URL}?action=delete_fb_post`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id })
        })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            Swal.fire('สำเร็จ', 'ลบประวัติโพสต์แล้ว', 'success');
            fetchPosts();
          }
        });
      }
    });
  };

  // 📢 สั่งโพสต์ขึ้น Facebook ทันที
  const handlePublishNow = (id, e) => {
    if (e) e.stopPropagation();
    Swal.fire({
      title: 'โพสต์ขึ้น Facebook แฟนเพจ?',
      text: 'ระบบจะทำการยิงโพสต์ขึ้นหน้าแฟนเพจหลักของคุณทันทีตามข้อมูลที่มี',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#1877f2',
      confirmButtonText: 'ยืนยันสั่งโพสต์',
      cancelButtonText: 'ยกเลิก'
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({ title: 'กำลังเชื่อมโยง Facebook API...', didOpen: () => Swal.showLoading() });
        fetch(`${API_URL}?action=trigger_fb_post_now`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id })
        })
        .then(res => res.json())
        .then(data => {
          Swal.close();
          if (data.success) {
            Swal.fire('สำเร็จ!', 'โพสต์คอนเทนต์ขึ้นแฟนเพจเฟสบุ๊กเรียบร้อยแล้ว!', 'success');
            fetchPosts();
          } else {
            // โพสต์ล้มเหลว (เช่น Token หมดอายุ) ให้ก๊อปปี้ไปโพสต์เอง
            Swal.fire({
              title: 'การโพสต์อัตโนมัติขัดข้อง',
              text: 'ไม่สามารถโพสต์ผ่านระบบ API ได้โดยตรง (อาจเนื่องจาก Facebook Token หมดอายุตามอายุรักษาความปลอดภัย) คุณสามารถคลิกปุ่มเพื่อคัดลอกข้อความไปโพสต์หน้าเพจเองได้เลยครับ',
              icon: 'warning',
              showCancelButton: true,
              confirmButtonText: '📋 คัดลอกแคปชั่นคำอธิบาย',
              cancelButtonText: 'ปิดหน้าต่าง'
            }).then((act) => {
              if (act.isConfirmed) {
                navigator.clipboard.writeText(data.caption_to_copy || '');
                Swal.fire('คัดลอกแล้ว', 'คัดลอกข้อความใส่คลิปบอร์ดแล้ว นำไปวางโพสต์ได้เลยครับ', 'success');
              }
            });
          }
        });
      }
    });
  };

  // 📋 ก๊อปปี้ข้อความต่างๆ
  const copyToClipboard = (text, message = 'คัดลอกลงคลิปบอร์ดแล้ว') => {
    navigator.clipboard.writeText(text);
    Swal.fire({
      title: 'คัดลอกสำเร็จ',
      text: message,
      icon: 'success',
      timer: 1500,
      showConfirmButton: false
    });
  };

  // 💾 บันทึกเฉพาะพรีวิวรูปภาพ (Image URL) ด่วนทางขวา
  const handleSaveImageUrlDirect = () => {
    if (!selectedPost) return;
    fetch(`${API_URL}?action=update_fb_post`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        ...selectedPost,
        image_url: selectedPost.image_url
      })
    })
    .then(res => res.json())
    .then(data => {
      if (data.success) {
        Swal.fire('สำเร็จ', 'บันทึกรูปภาพประกอบคิวโพสต์นี้เรียบร้อยแล้ว', 'success');
        fetchPosts();
      }
    });
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'posted':
        return <span className="px-2 py-0.5 bg-green-100 text-green-700 dark:bg-green-950 dark:text-green-400 border border-green-200 dark:border-green-900 rounded text-[9px] font-black">🟢 โพสต์สำเร็จ</span>;
      case 'failed':
        return <span className="px-2 py-0.5 bg-red-100 text-red-700 dark:bg-red-950 dark:text-red-400 border border-red-200 dark:border-red-900 rounded text-[9px] font-black">🔴 ยิงล้มเหลว</span>;
      default:
        return <span className="px-2 py-0.5 bg-orange-100 text-orange-700 dark:bg-orange-950 dark:text-orange-400 border border-orange-200 dark:border-orange-900 rounded text-[9px] font-black">⏳ รอดำเนินการ</span>;
    }
  };

  return (
    <div className="space-y-6 pb-20 animate-fade-in text-gray-800 dark:text-gray-100">
      
      {/* ส่วนหัวหน้าจอ */}
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4">
        <div>
          <h1 className="text-2xl font-black text-gray-800 dark:text-white flex items-center gap-2">
            <FiFacebook className="text-[#1877f2]" /> แผนกโพสต์แฟนเพจเฟสบุ๊กความรู้ไฟฟ้าอัตโนมัติ
          </h1>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-1">
            วางแผนเขียนคอนเทนต์ความรู้เรื่องไฟ แฮชแท็ก เจน Prompt และยิงโพสต์ขึ้นหน้าแฟนเพจเฟสบุ๊กโดยตรง
          </p>
        </div>
        <button 
          onClick={fetchPosts}
          className="p-2 bg-gray-100 dark:bg-[#1e293b] hover:bg-gray-200 dark:hover:bg-[#334155] rounded-xl flex items-center gap-1 text-xs font-bold transition shrink-0"
        >
          <FiRefreshCw size={12} className={isLoading ? 'animate-spin' : ''} /> รีเฟรชข้อมูล
        </button>
      </div>

      {/* แถบการสั่งงานด่วน */}
      <div className="bg-[#131825] p-4 rounded-2xl border border-[#1e2330] flex flex-col md:flex-row justify-between items-start md:items-center gap-4 text-left">
        <div className="flex flex-wrap items-center gap-3">
          <div className="flex flex-col">
            <span className="text-[9px] font-bold text-gray-400 uppercase mb-1">วันที่เริ่มต้นตารางโพสต์</span>
            <input 
              type="date" 
              value={startDate}
              onChange={e => setStartDate(e.target.value)}
              className="p-2 bg-[#1b2132] border border-[#2d3748] rounded-xl text-xs font-bold text-white outline-none focus:border-indigo-500"
            />
          </div>
          
          <button 
            onClick={handleGenerate30d}
            className="mt-4 px-4 py-2 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl text-xs shadow-md transition flex items-center gap-1.5"
          >
            <FiCpu size={14} /> 🤖 สุ่มสร้างแผนโพสต์ความรู้ไฟฟ้า 30 วัน
          </button>
        </div>

        <button 
          onClick={() => {
            setModalForm({
              id: null,
              post_date: new Date().toISOString().split('T')[0],
              title: '',
              caption: '',
              hashtags: '',
              image_prompt: '',
              image_url: '',
              status: 'pending'
            });
            setIsModalOpen(true);
          }}
          className="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white font-bold rounded-xl text-xs shadow-md transition flex items-center gap-1.5"
        >
          <FiPlusCircle size={14} /> เขียนโพสต์นัดหมายเอง (Manual)
        </button>
      </div>

      {/* โซนหลัก 2 Column */}
      <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 text-left">
        
        {/* คอลัมน์ซ้าย: รายชื่อคิวโพสต์ล่วงหน้า (3/5) */}
        <div className="lg:col-span-3 bg-white dark:bg-[#1e293b] rounded-2xl border border-gray-200 dark:border-[#334155] shadow-sm overflow-hidden flex flex-col">
          <div className="p-4 border-b border-gray-200 dark:border-[#334155] flex justify-between items-center bg-gray-50 dark:bg-[#131825]">
            <h3 className="text-sm font-black text-gray-800 dark:text-white flex items-center gap-1.5">
              📅 แผนคอนเทนต์โพสต์ล่วงหน้าในฐานข้อมูล ({posts.length} โพสต์)
            </h3>
          </div>

          <div className="overflow-y-auto max-h-[600px] divide-y divide-gray-150 dark:divide-[#334155] custom-scrollbar">
            {isLoading ? (
              <div className="text-center py-20 font-bold text-indigo-500 animate-pulse">กำลังสืบค้นปฏิทินโพสต์...</div>
            ) : posts.length > 0 ? (
              posts.map((post) => (
                <div 
                  key={post.id} 
                  onClick={() => setSelectedPost(post)}
                  className={`p-4 cursor-pointer transition-all flex items-start justify-between gap-4 ${
                    selectedPost?.id === post.id 
                      ? 'bg-indigo-50/50 dark:bg-indigo-950/20 border-l-4 border-indigo-500' 
                      : 'hover:bg-gray-50 dark:hover:bg-[#0f172a]/30'
                  }`}
                >
                  <div className="space-y-1.5 flex-1 min-w-0">
                    <div className="flex items-center gap-2">
                      <span className="text-[10px] font-bold font-mono text-gray-400 bg-gray-100 dark:bg-[#0f172a] px-2 py-0.5 rounded flex items-center gap-0.5">
                        <FiCalendar /> {post.post_date}
                      </span>
                      {getStatusBadge(post.status)}
                    </div>
                    <h4 className="text-xs font-black text-gray-900 dark:text-white truncate">{post.title}</h4>
                    <p className="text-[11px] text-gray-500 dark:text-gray-400 line-clamp-2">{post.caption}</p>
                  </div>

                  <div className="flex items-center gap-1.5 shrink-0">
                    <button 
                      onClick={(e) => {
                        e.stopPropagation();
                        setModalForm({ ...post });
                        setIsModalOpen(true);
                      }}
                      className="p-1.5 bg-yellow-50 hover:bg-yellow-100 text-yellow-600 rounded-lg transition"
                      title="แก้ไขข้อมูลโพสต์"
                    >
                      <FiEdit3 size={12} />
                    </button>
                    <button 
                      onClick={(e) => handlePublishNow(post.id, e)}
                      className="p-1.5 bg-blue-50 hover:bg-blue-100 text-blue-600 rounded-lg transition"
                      title="โพสต์ขึ้นเพจทันที"
                    >
                      <FiSend size={12} />
                    </button>
                    <button 
                      onClick={(e) => handleDeletePost(post.id, e)}
                      className="p-1.5 bg-red-50 hover:bg-red-100 text-red-600 rounded-lg transition"
                      title="ลบโพสต์นี้"
                    >
                      <FiTrash2 size={12} />
                    </button>
                  </div>
                </div>
              ))
            ) : (
              <div className="text-center py-20 text-gray-400 italic">
                ยังไม่มีตารางแผนโพสต์ความรู้เรื่องไฟฟ้าในระบบ<br />
                คลิกปุ่ม 🤖 สุ่มสร้างแผนโพสต์ 30 วัน ด้านบน เพื่อเริ่มสร้างตารางโพสต์อัตโนมัติ
              </div>
            )}
          </div>
        </div>

        {/* คอลัมน์ขวา: Mockup พรีวิวและตัวช่วยเจนรูปภาพ AI (2/5) */}
        <div className="lg:col-span-2 space-y-6">
          
          {selectedPost ? (
            <>
              {/* ส่วนที่ 1: Facebook Post Mockup */}
              <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-gray-200 dark:border-[#334155] shadow-sm p-4 text-left">
                <div className="flex justify-between items-center mb-3">
                  <span className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">📱 หน้าตาพรีวิวโพสต์บนมือถือ</span>
                  {selectedPost.status === 'posted' && (
                    <span className="text-[10px] text-green-500 font-bold">✓ โพสต์สำเร็จแล้ว</span>
                  )}
                </div>

                {/* FB Post Container */}
                <div className="border border-gray-200 dark:border-[#334155] rounded-xl overflow-hidden bg-white dark:bg-[#0f172a]">
                  {/* หัวโพสต์ */}
                  <div className="flex items-center gap-2 p-3">
                    <div className="w-9 h-9 rounded-full bg-blue-600 flex items-center justify-center text-white font-black text-sm shadow-inner">⚡</div>
                    <div>
                      <div className="text-xs font-bold text-gray-900 dark:text-white flex items-center gap-1">
                        Thunder MaxHome <span className="text-[10px] text-blue-500">✓</span>
                      </div>
                      <div className="text-[9px] text-gray-400 flex items-center gap-1 font-mono">
                        {selectedPost.post_date} · 🌎
                      </div>
                    </div>
                  </div>

                  {/* ข้อความบรรยายโพสต์ */}
                  <div className="px-3 pb-3 space-y-2 text-xs text-gray-800 dark:text-gray-200 leading-relaxed whitespace-pre-wrap">
                    <p className="font-extrabold text-indigo-500 dark:text-indigo-400">📢 {selectedPost.title}</p>
                    <p>{selectedPost.caption}</p>
                    <p className="text-blue-500 font-mono mt-2">{selectedPost.hashtags}</p>
                  </div>

                  {/* รูปภาพประกอบ */}
                  <div className="bg-gray-100 dark:bg-[#1e293b] min-h-[220px] flex items-center justify-center relative border-t border-gray-200 dark:border-[#334155]">
                    {selectedPost.image_url && selectedPost.image_url.trim() ? (
                      <img 
                        src={selectedPost.image_url} 
                        alt="Facebook Post content" 
                        className="w-full h-auto object-cover max-h-60"
                      />
                    ) : (
                      <div className="p-6 text-center text-gray-400 dark:text-gray-500 text-xs flex flex-col items-center justify-center gap-2">
                        <FiImage size={32} />
                        <p className="font-bold text-gray-600 dark:text-gray-400">ยังไม่ได้ใส่ลิงก์รูปภาพประกอบโพสต์นี้</p>
                        <p className="text-[10px] max-w-[220px] leading-tight">สามารถคัดลอกข้อความ Prompt ด้านล่างไปสร้างรูปผ่าน AI แล้วนำลิงก์มาวางได้เลยครับ</p>
                      </div>
                    )}
                  </div>

                  {/* ปุ่มไลค์ แชร์จำลอง */}
                  <div className="flex border-t border-gray-150 dark:border-[#334155] text-[10px] text-gray-500 font-bold p-2 justify-around bg-gray-50 dark:bg-[#131825]">
                    <span>👍 ถูกใจ</span>
                    <span>💬 แสดงความคิดเห็น</span>
                    <span>📤 แชร์</span>
                  </div>
                </div>

                {/* สั่งโพสต์ขึ้นเพจเดี๋ยวนี้ */}
                <button 
                  onClick={() => handlePublishNow(selectedPost.id)}
                  className="w-full py-2.5 bg-blue-600 hover:bg-blue-700 text-white font-bold rounded-xl text-xs shadow-md transition flex items-center justify-center gap-1.5 mt-4"
                >
                  <FiFacebook size={14} /> โพสต์ขึ้นเพจเดี๋ยวนี้ (Publish Now)
                </button>
              </div>

              {/* ส่วนที่ 2: AI Image Generator Prompt */}
              <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-gray-200 dark:border-[#334155] shadow-sm p-5 space-y-4 text-left">
                <div className="flex justify-between items-center">
                  <h3 className="font-black text-xs text-indigo-500 uppercase tracking-wider flex items-center gap-1">
                    <FiCpu /> คัดลอกข้อความ Prompt สำหรับไปเจนรูปภาพ AI
                  </h3>
                  <button 
                    onClick={() => copyToClipboard(selectedPost.image_prompt, 'คัดลอกข้อความ Prompt เจนรูปแล้ว')}
                    className="p-1 bg-indigo-50 hover:bg-indigo-100 dark:bg-indigo-950/40 text-indigo-600 rounded text-[10px] font-bold flex items-center gap-0.5 transition"
                  >
                    <FiCopy size={10} /> คัดลอก Prompt
                  </button>
                </div>

                <div className="bg-gray-50 dark:bg-[#0f172a] p-3 rounded-xl border border-gray-200 dark:border-[#334155] font-mono text-[10.5px] text-gray-700 dark:text-gray-300 select-all leading-normal">
                  {selectedPost.image_prompt || 'ไม่มีข้อความ Prompt สำหรับโพสต์นี้'}
                </div>

                <p className="text-[10px] text-gray-400 italic">
                  💡 คำแนะนำ: นำข้อความ Prompt นี้ไปวางในเครื่องมือสร้างรูปภาพ AI เช่น Midjourney, Leonardo, หรือ Bing Image Creator เพื่อสร้างรูปสเปกตรงใจ จากนั้นนำ URL ภาพมาผูกด้านล่าง
                </p>

                {/* ส่วนเชื่อมโยง Image URL */}
                <div className="pt-3 border-t border-gray-200 dark:border-gray-700 space-y-2">
                  <label className="text-[10px] font-bold text-gray-400 block">ลิงก์ที่อยู่รูปภาพประกอบ (Image URL)</label>
                  <div className="flex gap-2">
                    <input 
                      type="url" 
                      placeholder="เช่น https://imgur.com/image.jpg หรือลิงก์จากเซิร์ฟเวอร์"
                      value={selectedPost.image_url || ''}
                      onChange={e => setSelectedPost({ ...selectedPost, image_url: e.target.value })}
                      className="flex-1 p-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs outline-none focus:border-indigo-500 text-gray-800 dark:text-white"
                    />
                    <button 
                      onClick={handleSaveImageUrlDirect}
                      className="px-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-lg text-xs font-bold transition flex items-center gap-1 shrink-0 shadow"
                    >
                      <FiSave size={12} /> บันทึกรูป
                    </button>
                  </div>
                </div>
              </div>
            </>
          ) : (
            <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-gray-200 dark:border-[#334155] p-10 text-center text-gray-400">
              กรุณาเลือกหรือสร้างคิวงานโพสต์ทางซ้าย เพื่อดูพรีวิวหน้าจอการโพสต์แฟนเพจ
            </div>
          )}

        </div>

      </div>

      {/* 📝 MODAL สร้าง/แก้ไขโพสต์นัดหมาย (สร้างโดยตรง / แมนนวล) */}
      {isModalOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4 animate-fade-in text-gray-800">
          <div className="bg-white dark:bg-[#131825] dark:text-white w-full max-w-lg rounded-2xl shadow-2xl border border-gray-200 dark:border-[#334155] overflow-hidden text-left">
            
            <div className="bg-indigo-600 text-white p-4 flex justify-between items-center border-b border-indigo-700">
              <h3 className="font-black text-sm flex items-center gap-1.5">
                <span>{modalForm.id ? '✏️ แก้ไขข้อมูลตารางโพสต์' : '➕ สร้างคิวงานโพสต์ใหม่'}</span>
              </h3>
              <button 
                onClick={() => setIsModalOpen(false)} 
                className="text-white/80 hover:text-white transition p-1"
              >
                <FiX size={18} />
              </button>
            </div>

            <form onSubmit={handleSavePost} className="p-5 space-y-4">
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-1">
                  <label className="text-[10px] font-bold text-gray-400">วันที่จองโพสต์ลงเพจ</label>
                  <input 
                    type="date" 
                    value={modalForm.post_date}
                    onChange={e => setModalForm({...modalForm, post_date: e.target.value})}
                    className="w-full p-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs"
                    required
                  />
                </div>
                
                <div className="space-y-1">
                  <label className="text-[10px] font-bold text-gray-400">สถานะคิวงาน</label>
                  <select 
                    value={modalForm.status}
                    onChange={e => setModalForm({...modalForm, status: e.target.value})}
                    className="w-full p-2 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-lg text-xs font-bold"
                  >
                    <option value="pending">⏳ รอดำเนินการ (Pending)</option>
                    <option value="posted">🟢 โพสต์สำเร็จแล้ว (Posted)</option>
                    <option value="failed">🔴 ล้มเหลวขัดข้อง (Failed)</option>
                  </select>
                </div>
              </div>

              <div className="space-y-1">
                <label className="text-[10px] font-bold text-gray-400">หัวข้อหลักของโพสต์</label>
                <input 
                  type="text" 
                  value={modalForm.title}
                  onChange={e => setModalForm({...modalForm, title: e.target.value})}
                  placeholder="เช่น 5 วิธีการตรวจเช็คปลั๊กไฟ"
                  className="w-full p-2.5 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-xl text-xs"
                  required
                />
              </div>

              <div className="space-y-1">
                <label className="text-[10px] font-bold text-gray-400">คำบรรยายหลัก (Caption)</label>
                <textarea 
                  value={modalForm.caption}
                  onChange={e => setModalForm({...modalForm, caption: e.target.value})}
                  rows="4"
                  placeholder="พิมพ์คำอธิบาย แนะนำ ปรึกษา และประเด็นความปลอดภัยเรื่องไฟ..."
                  className="w-full p-2.5 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-xl text-xs resize-none"
                  required
                />
              </div>

              <div className="space-y-1">
                <label className="text-[10px] font-bold text-gray-400">แฮชแท็กประกอบโพสต์</label>
                <input 
                  type="text" 
                  value={modalForm.hashtags}
                  onChange={e => setModalForm({...modalForm, hashtags: e.target.value})}
                  placeholder="เช่น #ช่างไฟ #ความมั่นคงระบบไฟ #ปลอดภัย"
                  className="w-full p-2.5 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-xl text-xs font-mono"
                />
              </div>

              <div className="space-y-1">
                <label className="text-[10px] font-bold text-gray-400">ข้อความ Prompt เจนรูปภาพ AI</label>
                <textarea 
                  value={modalForm.image_prompt}
                  onChange={e => setModalForm({...modalForm, image_prompt: e.target.value})}
                  rows="2"
                  placeholder="คำอธิบายภาษาอังกฤษสำหรับนำไปสุ่มเจนรูปประกอบใน Midjourney..."
                  className="w-full p-2.5 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-xl text-xs font-mono"
                />
              </div>

              <div className="space-y-1">
                <label className="text-[10px] font-bold text-gray-400">ลิงก์ URL รูปภาพประกอบ (Image URL)</label>
                <input 
                  type="url" 
                  value={modalForm.image_url}
                  onChange={e => setModalForm({...modalForm, image_url: e.target.value})}
                  placeholder="เช่น https://imgur.com/image.jpg"
                  className="w-full p-2.5 bg-gray-50 dark:bg-[#0f172a] border border-gray-300 dark:border-[#334155] rounded-xl text-xs"
                />
              </div>

              <div className="flex gap-3 pt-2">
                <button 
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="flex-1 py-2.5 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 font-bold rounded-xl text-xs transition"
                >
                  ยกเลิก
                </button>
                <button 
                  type="submit"
                  className="flex-1 py-2.5 bg-indigo-600 hover:bg-indigo-700 text-white font-bold rounded-xl text-xs shadow transition"
                >
                  บันทึกข้อมูลตารางโพสต์
                </button>
              </div>
            </form>

          </div>
        </div>
      )}

    </div>
  );
}
